import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) => state.classType.loading;
export const selectErrorMessage = (state: RootState) => state.classType.error;
export const classTypeResponse = (state: RootState) =>
  state.classType.classTypeResponse;
